import React from 'react';
import { Box, Container, useColorModeValue } from '@chakra-ui/react';
import { DataUploadView } from 'src/features/DataUpload/components/templates/DataUploadView';

export const DataUploadPage: React.FC = () => {
  const bgColor = useColorModeValue('white', 'background.dark.lowest');
  const textColor = useColorModeValue('gray.800', 'white');

  return (
    <Box bg={bgColor} color={textColor} w="100%" minH="100vh">
      <Container maxW="100%" px={12} py={8}>
        <Box maxW="100%">
          <DataUploadView />
        </Box>
      </Container>
    </Box>
  );
};
